/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Docent_Already_ExistsInputs */

const nl_invite_errors_docent_already_exists = /** @type {(inputs: Invite_Errors_Docent_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze docent is al toegevoegd aan de school`)
};

/**

* @param {Invite_Errors_Docent_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_docent_already_exists = /** @type {((inputs?: Invite_Errors_Docent_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Docent_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_docent_already_exists(inputs)
});
export { invite_errors_docent_already_exists as "invite.errors.docent_already_exists" }